.logo {
    max-width: 100%;
    max-height: 100%;

    --accent: var(--red);
}
